import { Outlet } from "react-router-dom";
import { NavBar } from "../components/NavBar";
import { Sidebar } from "../components/Sidebar";
import { PageTransition } from "../components/PageTransition";

const PrivateLayout = () => {
  return (
    <div className="flex flex-row w-full h-screen overflow-hidden gap-3 p-3 font-sans bg-bg text-ink animate-fade-in">
      <Sidebar />
      <div className="flex flex-col h-full w-full gap-3 min-w-0">
        <NavBar />
        <main className="h-full min-h-0 p-3">
          <PageTransition>
            <Outlet />
          </PageTransition>
        </main>
      </div>
    </div>
  );
};

export default PrivateLayout;
